import { link } from "./Api";
import { useContacts, usePrsInfo } from "./effects";

function ContactsList({ setInfo, updateEstablishedContacts, ...props }) {
	const contacts = useContacts();
	const prsInfo = usePrsInfo();
	const addContact = (id) =>
		link(id)
			.then(() => {
				updateEstablishedContacts();
				if (props.setAddDialogOpen) {
					props.setAddDialogOpen(false);
				}
			})
			.catch((ev) => {
				setInfo(ev);
			});
	return (
		<div className='contact-list'>
			{contacts
				.filter((contact) => contact.alias !== prsInfo.prs_alias)
				.map((contact, i) => {
					const isContactExist =
						props.establishedContacts.findIndex(
							(item) => item.alias === contact.alias
						) !== -1;
					return (
						<div key={i} className='contact'>
							{`${contact.alias}`}
							{isContactExist ? (
								<div>{`: контакт установлен`}</div>
							) : (
								<button
									className='contact-action'
									onClick={() => addContact(contact.reporter_id)}
								>
									установить контакт
								</button>
							)}
						</div>
					);
				})}
		</div>
	);
}

export default ContactsList;
